import React, { Component } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import calendar from '../../../../../assets/images/module/general/CalendarIcon.svg';
import moment from 'moment';
import { Popover, Stack, Tooltip } from '@mantine/core';
import dayjs from 'dayjs';

class CustomDatePicker extends Component {
    initialState={
        datePickerOpen: null,
        excludedDateMap: null,
        popoverOpened: null,
        hoverOverPoperOver: false
    }

    constructor(props) {
        super(props);
        this.state = this.initialState;
    }

    componentDidMount(){
        this.componentDidMountStuff();
    }

    componentDidUpdate(prevProps){
        if(prevProps.excludeDates?.length === 0 && this.props.excludeDates?.length > 0){
            this.componentDidMountStuff();
        }
    }

    componentDidMountStuff=()=>{
        const { excludeDates } = this.props;
        console.log('excludeDates: ', excludeDates);
        const excludedDateMap = new Map();
        excludeDates.forEach(ex => {
            const key = ex.date.toISOString().split('T')[0];
            excludedDateMap.set(key, ex);
        });

        this.setState({excludedDateMap});
    }

    findClosestIntervals=(selectedDate)=> {
        const {excludeIntervals} = this.props;
        const sel = dayjs(selectedDate);

        // previous: interval with end < selected date, closest end
        const previous = excludeIntervals
            .filter(i => dayjs(i.end).isBefore(sel))
            .sort((a, b) => dayjs(b.end).valueOf() - dayjs(a.end).valueOf())[0] || null;

        // next: interval with start > selected date, closest start
        const next = excludeIntervals
            .filter(i => dayjs(i.start).isAfter(sel))
            .sort((a, b) => dayjs(a.start).valueOf() - dayjs(b.start).valueOf())[0] || null;

        return { previous, next };
    }

    render(){
    const { isMobile, moveIn, moveOut, moveOutDateRestriction, emptyTenantGapsData, emptyTenantEdit, datePickerType, onDateChange, moveInDateRestriction, excludeDates, rentalUnitId, onSelect=()=>null, currentTenant, rentalUnits, excludeIntervals, tenantEdit=false, isOwnerMode } = this.props;
    const { datePickerOpen, excludedDateMap, popoverOpened, hoverOverPoperOver } = this.state;
        console.log('datePickerOpen: ', datePickerOpen);
        console.log('moveIn: ', moveOutDateRestriction);
    
    const nextDayAfterMoveOut = dayjs(moveOut?.value).add(1, 'day').toDate();
    const previousDayBeforeMoveIn = dayjs(moveIn?.value).subtract(1, 'day').toDate();    

    const nextDayFromMoveOutExcluded = excludeIntervals.find(interval =>
        dayjs(nextDayAfterMoveOut).isSame(dayjs(interval.end)) 
    );

    const previousDayFromMoveInExcluded = excludeIntervals.find(interval =>
        dayjs(previousDayBeforeMoveIn).isSame(dayjs(interval.end))
    );

    const closestIntervalsFromMoveOut = this.findClosestIntervals(moveOut?.value);
    const closestIntervalsFromMoveIn = this.findClosestIntervals(moveIn?.value);

    //console.log('nextDayFromMoveOutExcluded: ', nextDayFromMoveOutExcluded, previousDayFromMoveInExcluded);
    const currentTenantMoveInDate = new Date(dayjs(currentTenant?.in, 'DD.MM.YYYY').format());
    const currentRentalUnit = rentalUnits.find((unit)=> unit?.id === currentTenant?.rentalUnitId);
    console.log('currentTenant: ', currentTenant, currentRentalUnit);

    const onSelectEventHandler=(date)=>{
        const excluded = date ? excludeIntervals.find(interval => date >= interval.start && date <= interval.end) : undefined;
        if(excluded === undefined){
            this.setState({datePickerOpen: null});
            onSelect();
        }
    }
    return(
        <div 
        className={`calendar-input ${(datePickerType === 'move-in' && moveIn.err) ? 'calender-invalid' : ''}`}
        // onFocus={()=> {
        //     let updateDatePickerOpen = null;
        //     if(datePickerOpen === null){
        //         updateDatePickerOpen = datePickerType;
        //     }else if(datePickerOpen === datePickerType && popoverOpened === null){
        //         updateDatePickerOpen = null;
        //     }
        //     this.setState({datePickerOpen: updateDatePickerOpen});
        // }}
        onFocus={()=> this.setState({datePickerOpen: datePickerType})}
        //onBlur={()=> popoverOpened === null && this.setState({datePickerOpen: null})}
        >
            <img src={calendar} alt="calendar" 
            style={{cursor: 'pointer'}}
            // onClick={()=> {
            //     let updateDatePickerOpen = null;
            //     if(datePickerOpen === null){
            //         updateDatePickerOpen = datePickerType;
            //     }else if(datePickerOpen === datePickerType && popoverOpened === null){
            //         updateDatePickerOpen = null;
            //     }
            //     this.setState({datePickerOpen: updateDatePickerOpen});
            // }}
            />
            <div className="datepicker-popper-container">
                <DatePicker
                locale="de"
                id={`react-date-picker-${datePickerType}`}
                withPortal={isMobile}
                formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 1)}
                dateFormat="dd.MM.yyyy"
                customInput={<Form.Control required type="text" placeholder="TT.MM.JJJJ" />}
                style={{ display: 'block' }}
                placeholderText={'TT.MM.JJJJ'}
                selected={datePickerType === 'move-in' ? (moveIn.isSelected && moveIn.value) : (moveOut.isSelected && moveOut.value)}
                onChange={(date) => {
                    const excluded = date ? excludeIntervals.find(interval => date >= interval.start && date <= interval.end) : undefined;
                    if(excluded === undefined){
                        onDateChange(datePickerType === 'move-in' ? 'moveIn' : 'moveOut', date);
                    }
                }}//onDateChange(datePickerType === 'move-in' ? 'moveIn' : 'moveOut', e)}
                //excludeDates={excludeDates.map((excludeDate)=> excludeDate.date)}
                excludeDateIntervals={excludeIntervals.map(i => ({
                    start: i.start,
                    end: i.end
                }))}
                onSelect={(date)=> onSelectEventHandler(date)}
                onBlur={(e)=> onSelectEventHandler(new Date(dayjs(e.currentTarget.value, 'DD.MM.YYYY')))}//e.currentTarget.value === '' && onSelect()}
                shouldCloseOnSelect={hoverOverPoperOver ? false : true}
                shouldCloseOnClickOutside={hoverOverPoperOver ? false : true}
                open={hoverOverPoperOver ? true : undefined}
                //open={datePickerOpen === datePickerType}
                renderDayContents={(day, date) => {
                    // const key = date.toISOString().split('T')[0];
                    // const excluded = excludedDateMap.get(key);
                    const excluded = excludeIntervals.find(interval =>
                        date >= interval.start && date <= interval.end
                    );

                    console.log('excluded: ', excluded, date);
                    
                    const isCurrentTenantDate = tenantEdit ? false : date > currentTenantMoveInDate && (moveIn?.value ? date > moveIn?.value : true) && (moveOut?.value ? date < moveOut?.value : true);
                    console.log('isCurrentTenantDate: ', isCurrentTenantDate, date);
                    
                    
                    if (excluded || (moveOut?.value && date >= moveOut.value && datePickerType === 'move-in') || (moveIn?.value && date <= moveIn.value && datePickerType === 'move-out') || isCurrentTenantDate) {

                    // 2. Apply isOwnerMode conditions to all validation/overlap messages
                    let message = excluded?.message || null;
                    message = message ? message 
                    : 
                    (moveOut?.value && (date >= moveOut.value) && datePickerType === 'move-in') ? 
                        <span>{isOwnerMode ? `Das Startdatum muss vor dem Enddatum (${dayjs(moveOut.value).format('DD.MM.YYYY')}) liegen.` : `Das Einzugsdatum, muss vor dem Auszugsdatum (${dayjs(moveOut.value).format('DD.MM.YYYY')}) liegen.`}</span>
                    : 
                    (moveIn?.value && (date <= moveIn.value) && datePickerType === 'move-out') ? 
                        <span>{isOwnerMode ? `Das Enddatum muss nach dem Startdatum (${dayjs(moveIn.value).format('DD.MM.YYYY')}) liegen.` : `Das Auszugsdatum, muss nach dem Einzugsdatum (${dayjs(moveIn.value).format('DD.MM.YYYY')}) liegen.`}</span>
                    :
                    isCurrentTenantDate ?
                        datePickerType === 'move-in' ?
                            <span style={{maxWidth: '300px', whiteSpace: 'normal'}}>
                                Die {isOwnerMode ? 'Einheit' : 'Mieteinheit'} {currentRentalUnit?.name} ist hier durch den {isOwnerMode ? 'Eigentümer' : 'Mieter'} <span style={{color: '#5555FF', cursor: 'pointer', textDecoration: 'underline'}} onClick={()=> this.props.history.push(`${isOwnerMode ? '/user/condominiumOwner/information?condominiumOwnerId=' : '/user/tenant/information?tenantId='}` + currentTenant?.id, { unitId: currentRentalUnit?.id })}>{currentTenant?.name} ({currentTenant?.in} - {currentTenant?.out || 'aktuell'})</span> belegt. Wenn Sie dieses {isOwnerMode ? 'Startdatum' : 'Einzugsdatum'} wählen, dann wird das {isOwnerMode ? 'Eigentumsverhältnis' : 'Mietverhältnis'} automatisch zum Datum {dayjs(date - 1).format('DD.MM.YYYY')} beendet.
                            </span>
                        :
                        datePickerType === 'move-out' ?
                            <span style={{maxWidth: '300px', whiteSpace: 'normal'}}>
                                Die {isOwnerMode ? 'Einheit' : 'Mieteinheit'} {currentRentalUnit?.name} ist hier durch den {isOwnerMode ? 'Eigentümer' : 'Mieter'} <span style={{color: '#5555FF', cursor: 'pointer', textDecoration: 'underline'}} onClick={()=> this.props.history.push(`${isOwnerMode ? '/user/condominiumOwner/information?condominiumOwnerId=' : '/user/tenant/information?tenantId='}` + currentTenant?.id, { unitId: currentRentalUnit?.id })}>{currentTenant?.name} ({currentTenant?.in} - {currentTenant?.out || 'aktuell'})</span> belegt. Wenn Sie einen neuen {isOwnerMode ? 'Eigentümer' : 'Mieter'} hinzufügen, wird das aktuelle {isOwnerMode ? 'Eigentumsverhältnis' : 'Mietverhältnis'} zum {isOwnerMode ? 'Startdatum' : 'Einzugsdatum'} des neuen {isOwnerMode ? 'Eigentümers' : 'Mieters'} beendet.
                            </span>
                        :
                        null
                    :
                    null;
                    console.log('message: ', message);
                      return (
                        <Popover
                            opened={dayjs(popoverOpened).isSame(dayjs(date))}
                            closeOnClickOutside={true}
                            trapFocus={true}
                            closeOnEscape={false}
                            position="top"
                            offset={0} // Replaces gutter={0}
                            zIndex={999999}
                            transitionProps={{ duration: 800 }} // Replaces transitionDuration={800}
                        >
                            {/* 1. The Target replaces the old 'target' prop */}
                            <Popover.Target>
                                <div
                                    // Moved from old Popover root styles
                                    style={{ width: '100%' }} 
                                    
                                    // Moved from old Popover root props (this styles the actual calendar day)
                                    className={
                                        excluded ? 'react-datepicker__day--disabled'
                                        : (moveIn?.value && moveIn.value == date) ? 'selected-move-in-date' 
                                        : (moveOut?.value && moveOut.value == date) ? 'selected-move-out-date' 
                                        : ((moveIn?.value && moveOut?.value) && date > moveIn?.value && date < moveOut?.value) ? 'in-between-selected-move-in-out-date'
                                        : isCurrentTenantDate && 'current-tenant-dates'
                                    }
                                    onClick={(e) => e.preventDefault()}
                                    onMouseEnter={() => this.setState({ popoverOpened: date })} 
                                    onMouseLeave={() => this.setState({ popoverOpened: null })}
                                >
                                    {day}
                                </div>
                            </Popover.Target>

                            {/* 2. The Dropdown replaces the old children and styles.inner / styles.popover */}
                            <Popover.Dropdown
                                style={{
                                    background: 'rgb(227, 227, 252)',
                                    borderColor: 'rgb(227, 227, 252)',
                                    cursor: 'pointer',
                                    padding: '5px 10px'
                                }}
                            >
                                <Stack 
                                    gap={0} 
                                    className="tool-tip-for-tenants-excluded" 
                                    onMouseEnter={() => this.setState({ popoverOpened: date, hoverOverPoperOver: true })} 
                                    onMouseLeave={() => this.setState({ popoverOpened: null, hoverOverPoperOver: false })}
                                    onClick={(e) => e.preventDefault()}
                                >
                                    {message}
                                </Stack>
                            </Popover.Dropdown>
                        </Popover>
                      );
                    }

                    return <div className={excluded ? 'react-datepicker__day--disabled'
                        :
                        (moveIn?.value && moveIn.value == date) ? 
                        'selected-move-in-date' 
                        : 
                        (moveOut?.value && moveOut.value == date) ? 
                        'selected-move-out-date' 
                        : 
                        (moveIn?.value && moveOut?.value && date > moveIn?.value && date < moveOut?.value) ?
                        'in-between-selected-move-in-out-date'
                        :
                        isCurrentTenantDate && 'current-tenant-dates'} onMouseEnter={()=> this.setState({popoverOpened: null})}>{day}</div>;
                }}
                minDate={datePickerType === 'move-in' ? 
                (moveIn?.value && previousDayFromMoveInExcluded !== undefined ? dayjs(previousDayFromMoveInExcluded.end).add(1, 'day').toDate() : 
                closestIntervalsFromMoveIn.previous ? dayjs(closestIntervalsFromMoveIn.previous.end).add(1, 'day').toDate() :
                null) 
                : 
                ((moveIn.isSelected && moveIn?.value) ? moveOutDateRestriction : null)}
                maxDate={datePickerType === 'move-in' ? 
                ((moveOut?.isSelected && moveOut?.value) ? moveInDateRestriction :  null) 
                : 
                ((moveOut?.value && nextDayFromMoveOutExcluded !== undefined) ? dayjs(nextDayFromMoveOutExcluded.start).subtract(1, 'day').toDate() : 
                closestIntervalsFromMoveOut.next ? dayjs(closestIntervalsFromMoveOut.next.start).subtract(1, 'day').toDate() :
                (emptyTenantEdit && emptyTenantGapsData.moveOut && new Date(moment(emptyTenantGapsData.moveOut, 'DD.MM.YYYY').format('YYYY-MM-DDTHH:mm:ss'))))}
                />
            </div>
        </div>
    )
    }

}

export default CustomDatePicker;